import { ItemTimeLineData, ServiceOrder, WithPartial } from '@as-react/common-types';
import { AxiosRequestConfig } from 'axios';
import { axiosClient } from '@as-react/common-utils';
import { createUrl } from '../../utils/createUrl';
import { QueryApiOptions, UrlMapping } from '../../types/types';
import { trackingQueryKeys } from '../..';

export type TrackingParams = {
  hash: string;
};

const API_SH_BACKEND_APIKEY = 'apikey 50f157ef-620d-4cf2-9fb8-bfa0ead3f013';

const urlMapping: UrlMapping<typeof trackingQueryKeys> = {
  details: {
    client: 'api/sh/order/details',
  },
  timeline: {
    client: 'api/sh/order/timeline',
  },
};

export const getDetails = async (
  { servicesEndpoint, isServer, defaultRequestParams }: WithPartial<QueryApiOptions, 'defaultRequestParams'>,
  { hash }: TrackingParams
): Promise<ServiceOrder> => {
  const url = createUrl(servicesEndpoint, urlMapping.details, isServer);
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url,
    headers: {
      Authorization: API_SH_BACKEND_APIKEY,
    },
    params: { ...defaultRequestParams, hash },
    withCredentials: true,
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data?.data;
};

export const getTimeline = async (
  { servicesEndpoint, isServer, defaultRequestParams }: WithPartial<QueryApiOptions, 'defaultRequestParams'>,
  { hash }: TrackingParams
): Promise<Array<ItemTimeLineData>> => {
  const url = createUrl(servicesEndpoint, urlMapping.timeline, isServer);
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url,
    headers: {
      Authorization: API_SH_BACKEND_APIKEY,
    },
    params: { ...defaultRequestParams, hash },
    withCredentials: true,
  };

  const result = await axiosClient.request(axiosConfig);
  return result.data?.data;
};
